import formatPrice from '.'

describe('formatPrice', () => {
  describe('Если передано валидное числовое значение', () => {
    test('Тогда возвращает строку с форматированной ценой (2 знака после запятой)', () => {
      expect(formatPrice({ price: 100 })).toBe('100')
      expect(formatPrice({ price: 1000 })).toBe('1\xA0000')
      expect(formatPrice({ price: 1000000 })).toBe('1\xA0000\xA0000')
      expect(formatPrice({ price: 1739.12 })).toBe('1\xA0739,12')
      expect(formatPrice({ price: 0 })).toBe('0')
    })

    test('Тогда убирает лишние нули после запятой', () => {
      expect(formatPrice({ price: 100.50 })).toBe('100,50')
      expect(formatPrice({ price: 100.00 })).toBe('100')
    })
  })

  describe('Если передано числовое значение в строковом формате', () => {
    test('Тогда парсит строку и форматирует цену', () => {
      expect(formatPrice({ price: '100' })).toBe('100')
      expect(formatPrice({ price: '1739.12' })).toBe('1\xA0739,12')
      expect(formatPrice({ price: '0' })).toBe('0')
    })
  })

  describe('Если передано значение с валютным символом', () => {
    test('Тогда удаляет символы и форматирует цену', () => {
      expect(formatPrice({ price: '£1,739.12' })).toBe('1\xA0739,12')
      expect(formatPrice({ price: '$100.00' })).toBe('100')
      expect(formatPrice({ price: '€50,50' })).toBe('5\xA0050')
      expect(formatPrice({ price: '100 USD' })).toBe('100')
    })
  })

  describe('Если передано null', () => {
    test('Тогда возвращает пустую строку', () => {
      expect(formatPrice({ price: null })).toBe('')
    })
  })

  describe('Если передано undefined', () => {
    test('Тогда возвращает пустую строку', () => {
      expect(formatPrice({ price: undefined })).toBe('')
    })
  })

  describe('Если передано пустая строка', () => {
    test('Тогда возвращает пустую строку', () => {
      expect(formatPrice({ price: '' })).toBe('')
    })
  })

  describe('Если передано NaN или недопустимая строка', () => {
    test('Тогда возвращает пустую строку', () => {
      expect(formatPrice({ price: 'abc' })).toBe('')
      expect(formatPrice({ price: '---' })).toBe('')
    })
  })

  describe('Если передан объект', () => {
    test('Тогда возвращает пустую строку', () => {
      expect(formatPrice({ price: {} })).toBe('')
    })
  })

  describe('Краевые случаи', () => {
    test('Обрабатывает очень большие числа', () => {
      expect(formatPrice({ price: 999999999999 })).toBe('999\xA0999\xA0999\xA0999')
    })

    test('Обрабатывает очень маленькие числа', () => {
      expect(formatPrice({ price: 0.01 })).toBe('0,01')
      expect(formatPrice({ price: 0.99 })).toBe('0,99')
    })

    test('Обрабатывает числа с большим количеством знаков после запятой', () => {
      expect(formatPrice({ price: 100.123456 })).toBe('100,12')
      expect(formatPrice({ price: 99.999 })).toBe('100')
    })
  })

  describe('Опция useFreeTextForZero', () => {
    test('Если price = 0 и useFreeTextForZero = true, возвращает "Бесплатно"', () => {
      expect(formatPrice({ price: 0, useFreeTextForZero: true })).toBe('Бесплатно')
    })

    test('Если price = 0 и useFreeTextForZero = false, возвращает "0"', () => {
      expect(formatPrice({ price: 0, useFreeTextForZero: false })).toBe('0')
    })

    test('Если useFreeTextForZero = true и price ≠ 0, нормально форматирует', () => {
      expect(formatPrice({ price: 100, useFreeTextForZero: true })).toBe('100')
      expect(formatPrice({ price: 1739.12, useFreeTextForZero: true })).toBe('1\xA0739,12')
    })
  })

  describe('Опция currencySymbol', () => {
    test('Добавляет валютный символ после цены', () => {
      expect(formatPrice({ price: 100, currencySymbol: '₽' })).toBe('100 ₽')
      expect(formatPrice({ price: 1739.12, currencySymbol: '$' })).toBe('1\xA0739,12 $')
    })

    test('Работает с useFreeTextForZero - prefix и currencySymbol не добавляются при бесплатном', () => {
      // Примечание: функция возвращает "Бесплатно" без добавления prefix/currencySymbol при price === 0
      expect(formatPrice({ price: 0, useFreeTextForZero: true, currencySymbol: '₽' })).toBe('Бесплатно')
    })
  })

  describe('Опция prefix', () => {
    test('Добавляет префикс перед ценой', () => {
      expect(formatPrice({ price: 100, prefix: 'Цена' })).toBe('Цена 100')
      expect(formatPrice({ price: 1739.12, prefix: 'Стоимость:' })).toBe('Стоимость: 1\xA0739,12')
    })

    test('Работает с useFreeTextForZero - prefix и currencySymbol не добавляются при бесплатном', () => {
      // Примечание: функция возвращает "Бесплатно" без добавления prefix/currencySymbol при price === 0
      expect(formatPrice({ price: 0, useFreeTextForZero: true, prefix: 'Билет' })).toBe('Бесплатно')
    })
  })

  describe('Комбинация опций', () => {
    test('prefix + currencySymbol', () => {
      expect(formatPrice({ price: 100, prefix: 'Цена', currencySymbol: '₽' })).toBe('Цена 100 ₽')
    })

    test('prefix + useFreeTextForZero + currencySymbol - при бесплатном добавляется только "Бесплатно"', () => {
      // Примечание: функция возвращает "Бесплатно" без добавления prefix/currencySymbol при price === 0
      expect(formatPrice({
        price: 0,
        prefix: 'Взнос',
        useFreeTextForZero: true,
        currencySymbol: '₽',
      })).toBe('Бесплатно')

      expect(formatPrice({
        price: 500,
        prefix: 'Взнос',
        useFreeTextForZero: true,
        currencySymbol: '₽',
      })).toBe('Взнос 500 ₽')
    })
  })
})
